import React, { useState } from "react";

//components
import BtnRight from "../Components/common/ButtonRight";
import AutoCarousel from "../Components/Carousel";

//icons
import { LuGlobe } from "react-icons/lu";

//other images
import Reaching from "../../src/Assets/img/mobile/reaching.png";
import reactUI from "../../src/Assets/img/reactui.png";
import Healthcare from "../../src/Assets/img/mobile/healthcare.png";

//frames
import YawmFrame from "../../src/Assets/img/frames/yawm.png";
import YanaaFrame from "../../src/Assets/img/frames/yanaa.png";
import YanaaMob from "../../src/Assets/img/frames/yanaa-mob.png";
import AakruthiFrame from "../../src/Assets/img/frames/aakruti.png";
import SamratFrame from "../../src/Assets/img/frames/samrat.png";
import AishNaveenFrame from "../../src/Assets/img/frames/aishwaryanaveen.png";
import LookeastFrame from "../../src/Assets/img/frames/lookeast.png";
import CargoFrame from "../../src/Assets/img/frames/cargo.png";
import EneryFrame from "../../src/Assets/img/frames/energy.png";
import EneryMobFrame from "../../src/Assets/img/frames/energyMob.png";
import LAFrame from "../../src/Assets/img/frames/LA.png";
import MGRFrame from "../../src/Assets/img/frames/MGR.png";
import EntFrame from "../../src/Assets/img/frames/ent.png";
import InsuranceFrame from "../../src/Assets/img/frames/insurance.png";

//figma
import HealthcareFigma from "../../src/Assets/img/figma/healthcare-figma.png";
import YawmFigma from "../../src/Assets/img/figma/yawm.png";
import AakrutiFigma from "../../src/Assets/img/figma/aakruti-figma.png";
import YanaaFigma from "../../src/Assets/img/figma/yanaa-figma.png";
import ReachingFigma from "../../src/Assets/img/figma/reaching-figma.png";
import SamratFigma from "../../src/Assets/img/figma/samrat-figma.png";
import AishNaveenFigma from "../../src/Assets/img/figma/aishwaryanaveen.png";
import LookeastFigma from "../../src/Assets/img/figma/lookeast.png";
import MBFigma from "../../src/Assets/img/figma/mobileFirst.png";
import EM1Figma from "../../src/Assets/img/figma/EM1.png";
import EM2Figma from "../../src/Assets/img/figma/EM2.png";
import EM3Figma from "../../src/Assets/img/figma/EM3.png";
import LAFigma from "../../src/Assets/img/figma/LA.png";
import MGRFigma from "../../src/Assets/img/figma/MGR.png";
import EntFigma from "../../src/Assets/img/figma/ent.png";
import InsuranceFigma from "../../src/Assets/img/figma/insurance.png";

//information architecture
import InsuranceIA from "../../src/Assets/img/IA/insurance.png";

export default function RecentWorks() {
  const works = [
    {
      id: "bfsi",
      title: "An Insurance Agent App (BFSI)",
      description:
        "A comprehensive insurance agent service app that streamlines visits, lead management, applications, renewals, cases, performance tracking, and earnings in one platform.",
      images: [InsuranceFrame, InsuranceIA, InsuranceFigma],
      // website: "https://hotelaishwaryanaveen.com/",
      actions: [
        {
          label: "Figma Prototype",
          type: "primary-button",
          url: "https://www.figma.com/proto/EAHOR1jxlgQWE7wjZAyhXW/Enterprise-Demo?node-id=1-4686&p=f&t=xPD6MlqE1oxOv0ce-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=1%3A4686",
        },
        // {
        //   label: "Case Study",
        //   type: "secondary-button",
        //   url: "/caseStudy/yanaa.pdf",
        // },
      ],
    },
    {
      id: "ent",
      title: "An Enterprise Web App",
      description:
        "An enterprise web app that shows the data metrics/high data visuals of different verticles in a company",
      images: [EntFrame, EntFigma],
      // website: "https://hotelaishwaryanaveen.com/",
      actions: [
        {
          label: "Figma Prototype",
          type: "primary-button",
          url: "https://www.figma.com/proto/EAHOR1jxlgQWE7wjZAyhXW/Enterprise-Demo?node-id=1-4686&p=f&t=xPD6MlqE1oxOv0ce-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=1%3A4686",
        },
        // {
        //   label: "Case Study",
        //   type: "secondary-button",
        //   url: "/caseStudy/yanaa.pdf",
        // },
      ],
    },
    {
      id: "cement",
      title: "MGR Industry App",
      description:
        "A dedicated app for executives in manufacturing industry to streamline their daily operations. The app enables users to create and manage leads, convert leads into active sites, schedule and track event activities, and monitor progress through detailed reports.",
      images: [MGRFigma],
      // website: "https://hotelaishwaryanaveen.com/",
      actions: [
        {
          label: "Figma Prototype",
          type: "primary-button",
          url: "https://www.figma.com/proto/TnAO4T3WUT4dj5wXZU5so0/Product-Design?node-id=24-24207&t=qI6InQa6AOBcFWUL-1&scaling=min-zoom&content-scaling=fixed&page-id=24%3A3936",
        },
        // {
        //   label: "Case Study",
        //   type: "secondary-button",
        //   url: "/caseStudy/yanaa.pdf",
        // },
      ],
    },
    {
      id: "lostandfound",
      title: "Service App",
      description:
        "A smart aviation app designed to help passengers report, track, and recover essentials quickly and efficiently.",
      images: [LAFrame, LAFigma],
      // website: "https://hotelaishwaryanaveen.com/",
      actions: [
        {
          label: "Figma Prototype",
          type: "primary-button",
          url: "https://www.figma.com/proto/TnAO4T3WUT4dj5wXZU5so0/Product-Design?node-id=1-3950&p=f&t=A929HkLJzQ5dhn7a-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=1%3A3950",
        },
        // {
        //   label: "Case Study",
        //   type: "secondary-button",
        //   url: "/caseStudy/yanaa.pdf",
        // },
      ],
    },
    {
      id: "energy",
      title: "Energy Monitory System",
      description:
        "A responsive dashboard that tracks, analyzes, and visualizes energy consumption in real time, helping optimize usage and reduce costs.",
      images: [EneryFrame, EneryMobFrame, EM1Figma, EM2Figma, EM3Figma],
      // website: "https://hotelaishwaryanaveen.com/",
      actions: [
        {
          label: "Figma Prototype",
          type: "primary-button",
          url: "https://www.figma.com/proto/zeFZU6Gu0L5k9QPVmt3pJH/Energy_Monitoring_Dashboard?node-id=1-2&t=9RVQglRSGSOpC0iD-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=1%3A2",
        },
        // {
        //   label: "Case Study",
        //   type: "secondary-button",
        //   url: "/caseStudy/yanaa.pdf",
        // },
      ],
    },
    {
      id: "mobileFirst",
      title: "Cargo - A Mobile First Approve",
      description: "A responsive web",
      images: [CargoFrame, MBFigma],
      // website: "https://hotelaishwaryanaveen.com/",
      actions: [
        {
          label: "Figma Prototype",
          type: "primary-button",
          url: "https://www.figma.com/proto/fAUDyuB8NhlUoarV9rFJZD/Mobile-Design?node-id=3-2&p=f&t=wmecPcIFHG7Au6Br-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=3%3A2",
        },
        // {
        //   label: "Case Study",
        //   type: "secondary-button",
        //   url: "/caseStudy/yanaa.pdf",
        // },
      ],
    },
    {
      id: "lookeast",
      title: "Look East",
      description: "An educational website.",
      images: [LookeastFrame, LookeastFigma],
      // website: "https://hotelaishwaryanaveen.com/",
      actions: [
        {
          label: "Figma Prototype",
          type: "primary-button",
          url: "https://www.figma.com/proto/jrw2DaKzYqdspAAFkH59q8/Look-East-EDU?node-id=163-4124&t=9nnz0RhOz88WJeHj-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=163%3A4124",
        },
        // {
        //   label: "Case Study",
        //   type: "secondary-button",
        //   url: "/caseStudy/yanaa.pdf",
        // },
      ],
    },
    {
      id: "aishwaryanaveen",
      title: "Hotel Aishwarya Naveen",
      description: "A restaurant company.",
      images: [AishNaveenFrame, AishNaveenFigma],
      website: "https://hotelaishwaryanaveen.com/",
      actions: [
        {
          label: "Figma Prototype",
          type: "primary-button",
          url: "https://www.figma.com/proto/5fxPc2d4oJwLAHaCtwCLrn/Hotel_Aishwarya_Naveen?node-id=2-2&t=aHMW7KXq8KUqBUHh-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1",
        },
        // {
        //   label: "Case Study",
        //   type: "secondary-button",
        //   url: "/caseStudy/yanaa.pdf",
        // },
      ],
    },
    {
      id: "yawm",
      title: "Yawm Tech Solutions",
      description: "A software company.",
      images: [YawmFrame, YawmFigma],
      website: "https://yawmtechsolutions.in/",
      actions: [
        {
          label: "Figma Prototype",
          type: "primary-button",
          url: "https://www.figma.com/proto/ly2izhHf98dgEeAIJTRGXC/Yawmtechsolutions?node-id=1-2&t=9WPcEuuQDCI9WdoT-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=1%3A2",
        },
        // {
        //   label: "Case Study",
        //   type: "secondary-button",
        //   url: "/caseStudy/yanaa.pdf",
        // },
      ],
    },
    {
      id: "samrat",
      title: "Samrat Ventures",
      description: "A construction company.",
      images: [SamratFrame, SamratFigma],
      website: "https://samratventures.in/",
      actions: [
        {
          label: "Figma Prototype",
          type: "primary-button",
          url: "https://www.figma.com/proto/0lBMFhK8zBeqMYFIiZZXNQ/samrat_vantures?t=3pWpKDr4V7syOIqA-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&node-id=1-2&starting-point-node-id=1%3A2",
        },
        // {
        //   label: "Case Study",
        //   type: "secondary-button",
        //   url: "/caseStudy/yanaa.pdf",
        // },
      ],
    },
    {
      id: "yanaa",
      title: "Yanaa Homes - Website redesign",
      description: "An interior design company.",
      images: [YanaaFrame, YanaaMob, YanaaFigma],
      website: "https://yanaahomes.com/",
      actions: [
        {
          label: "Figma Prototype",
          type: "primary-button",
          url: "https://www.figma.com/proto/8pmpZeMzlryvkMgRVJrHUO/Yanaa-Homes?node-id=1-4&t=tB7VBMawby4IMG1J-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=1%3A4",
        },
        {
          label: "Case Study",
          type: "secondary-button",
          url: "/caseStudy/yanaa.pdf",
        },
      ],
    },
    {
      id: "aakruthi",
      title: "Aakruthi - A Responsive Web Design",
      description: "An ayurvedic and cosmetology company.",
      images: [AakruthiFrame, AakrutiFigma],
      website: "https://aakruthihealthcare.com/",
      actions: [
        {
          label: "Figma Prototype",
          type: "primary-button",
          url: "https://www.figma.com/proto/GpMwIaZUNcN64RtXPupWOz/Aakruthi_web_prototype?node-id=1-4&p=f&t=2U8bLQhN12wpJFPs-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=1%3A4",
        },
        // {
        //   label: "Case Study",
        //   type: "secondary-button",
        //   url: "/works/uxui/aakruthi",
        // },
      ],
    },
    {
      id: "healthcare",
      title: "Healthcare Mobile App",
      description:
        "Application that allows users to find top doctors, pharmacy & ambulance. Features yet to be enhanced.",
      images: [Healthcare, HealthcareFigma],
      // website: "https://demo-healthcare-app.example.com",
      actions: [
        {
          label: "Figma Prototype",
          type: "primary-button",
          url: "https://www.figma.com/proto/EtUhniB9uGWHHDEvELJOHm/Healthcare-App?node-id=1-419&t=P7mjx6q0ZCD6uFBO-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=1%3A10",
        },
        // {
        //   label: "Case Study",
        //   type: "secondary-button",
        //   url: "https://www.figma.com/proto/EtUhniB9uGWHHDEvELJOHm/Healthcare-App?node-id=1-419&t=P7mjx6q0ZCD6uFBO-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=1%3A10",
        // },
      ],
    },
    {
      id: "reaching",
      title: "Reaching Mobile App",
      description:
        "A location sharing application where any user can share their trip plan for the day to their loved ones.",
      images: [Reaching, ReachingFigma],
      // website: "https://reaching-app.example.com",
      actions: [
        {
          label: "Figma Prototype",
          type: "primary-button",
          url: "https://www.figma.com/proto/IOpVtjvb8ftwE2bqSnfcZs/Reaching_Location_Sharing_App?type=design&node-id=1-2&t=RBKSGfZDC0ePcCaQ-1&scaling=scale-down&page-id=0%3A1&starting-point-node-id=1%3A2&mode=design",
        },
      ],
    },
    {
      id: "reactui",
      title: "React UI Components | NPM Package",
      description:
        "NPM package that lets React developers use UI components effortlessly.",
      images: [reactUI],
      // website: "https://github.com/iamnikitamallya/react-ui-components", // 👈 example
      actions: [
        {
          label: "NPM",
          type: "primary-button",
          url: "https://www.npmjs.com/package/@nikitamallya/react-ui-components",
        },
        {
          label: "GitHub",
          type: "secondary-button",
          url: "https://github.com/iamnikitamallya/react-ui-components",
        },
      ],
    },
  ];

  // ---- Filtering Logic ----
  const getCategories = (work) => {
    const categories = [];

    if (work.actions?.some((a) => a.label.toLowerCase() === "case study")) {
      categories.push("case"); // Case Studies & Prototypes
    }

    if (work.website) {
      categories.push("dev"); // UI Development
    }

    if (categories.length === 0) {
      categories.push("other"); // Fallback
    }

    return categories;
  };

  const [activeFilter, setActiveFilter] = useState("all");

  const filteredWorks =
    activeFilter === "all"
      ? works
      : works.filter((w) => getCategories(w).includes(activeFilter));
  return (
    <>
      <h2 className="text-center">My Recent Works</h2>

      {/* Filter buttons */}
      <div className="doubleBtn">
        <BtnRight
          label="Figma Prototypes"
          className={
            activeFilter === "all" ? "primary-button" : "secondary-button"
          }
          to="#"
          onClick={() => setActiveFilter("all")}
        />
        <BtnRight
          label="Case Studies"
          className={
            activeFilter === "case" ? "primary-button" : "secondary-button"
          }
          to="#"
          onClick={() => setActiveFilter("case")}
        />
        <BtnRight
          label="UI Development"
          className={
            activeFilter === "dev" ? "primary-button" : "secondary-button"
          }
          to="#"
          onClick={() => setActiveFilter("dev")}
        />
        {/* <BtnRight
          label="Other Works"
          className={
            activeFilter === "other" ? "primary-button" : "secondary-button"
          }
          to="#"
          onClick={() => setActiveFilter("other")}
        /> */}
      </div>

      {/* Works grid */}
      <div className="row pb-4">
        {filteredWorks.map((work) => (
          <div className="col-md-6 pb-4" key={work.id}>
            <div className="workCard">
              <h2>{work.title}</h2>
              <p>{work.description}</p>
              <div className="doubleBtn">
                {work.actions.map((action, idx) => (
                  <BtnRight
                    key={idx}
                    label={action.label}
                    className={action.type}
                    to={action.url}
                  />
                ))}
                {work.website && (
                  <a
                    href={work.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="web"
                  >
                    <LuGlobe />
                  </a>
                )}
              </div>
              <AutoCarousel
                images={work.images}
                interval={3000}
                altPrefix={work.title}
              />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
